<div *ngIf="isLoading$ | async" class="loading-overlay w-full h-full flex align-items-center justify-content-center">
    <p-progressSpinner></p-progressSpinner>
</div>